import { render } from "./CreateProject.vue?vue&type=template&id=060d725f&scoped=true"
import script from "./CreateProject.vue?vue&type=script&lang=js"
export * from "./CreateProject.vue?vue&type=script&lang=js"

import "./CreateProject.vue?vue&type=style&index=0&id=060d725f&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-060d725f"]])

export default __exports__